import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UaService } from '@ecm/consumer';

import { MaterialAccordionItemModel } from '../../business/material-accordion-item-model';
import { SeoImage } from '../../business/seo/seo-image';
import { SeoWidgetItem } from '../../business/seo/seo-widget-item';
import { MaterialSeoService } from '../../services/material-seo.service';
import { MaterialAccordionsComponent } from '../material-accordions/material-accordions.component';
import { MaterialSeoCtaComponent } from './cta/material-seo-cta.component';
import { MaterialSeoLoginComponent } from './login/material-seo-login.component';
import { MaterialSeoQrCodeComponent } from './qr-code/material-seo-qr-code.component';
import { MaterialSeoReasonsComponent } from './reasons/material-seo-reasons.component';
import { MaterialSeoWidgetsComponent } from './widgets/material-seo-widgets.component';

@Component({
    selector: 'ecm-mat-seo',
    templateUrl: 'material-seo.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MaterialAccordionsComponent,
        MaterialSeoLoginComponent,
        MaterialSeoQrCodeComponent,
        MaterialSeoReasonsComponent,
        MaterialSeoWidgetsComponent,
        MaterialSeoCtaComponent,
    ],
})
export class MaterialSeoComponent implements OnInit {
    @Input({ required: true }) public title: string;
    @Input({ required: true }) public description: string | string[];
    @Input() public image?: SeoImage;

    @Input() public hasLoginLink = false;

    @Input() public hasNativeAppLink = false;
    @Input() public native?: { url: string };

    @Input() public accordionTitle?: string;
    @Input() public accordionItems?: MaterialAccordionItemModel[];

    @Input() public reasonTitle?: string;
    @Input() public reasonSubTitle?: string;
    @Input() public reasonItems?: string[];
    @Input() public reasonCaption?: string;

    @Input() public richSnippets?: any;

    @Input() public widgetTitle?: string;
    @Input() public widgetSubTitle?: string;
    @Input() public widgetItems?: SeoWidgetItem[];

    @Input() public buttonLoginAriaLabel?: string;
    @Input() public buttonLoginLabel?: string;
    @Input() public entryPoints: any[];

    @Input() public e2e = 'e2e-mat-seo';

    @Output() public login = new EventEmitter<void>();
    @Output() public findIdentifier = new EventEmitter<void>();
    @Output() public clickWidgetButton = new EventEmitter<number>();
    @Output() public clickAccordionLink = new EventEmitter<any>();
    @Output() public clickCtaButton = new EventEmitter<number>();
    public constructor(
        private readonly seoService: MaterialSeoService,
        private readonly uaService: UaService,
    ) {}

    public get buttonLoginStyle(): 'primary' | 'secondary' {
        return this.canInstallNativeApp && this.hasNativeAppLink ? 'secondary' : 'primary';
    }

    /**
     * Current device can install native app
     * @returns {boolean}
     */
    public get canInstallNativeApp(): boolean {
        return this.uaService.isMobile() || this.uaService.isTablet();
    }

    public get withAccordions(): boolean {
        return this.accordionItems?.length > 0;
    }

    public get withReasons(): boolean {
        return this.reasonItems?.length > 0;
    }

    public get withWidgets(): boolean {
        return this.widgetItems?.length > 0;
    }

    public get withCTA(): boolean {
        return this.entryPoints?.length > 0;
    }

    public ngOnInit(): void {
        // force description to be an array
        this.description = Array.isArray(this.description) ? this.description : [this.description];
        // Set structured data
        if (this.richSnippets) {
            this.seoService.generateStructuredData(this.richSnippets);
        }
    }
}
